import Types from '../types'

const initialState = {
    themeType: "light",
    allRegions: [
        "us-east-2",
        "us-east-1",
        "us-west-1",
        "us-west-2",
        "af-south-1",
        "ap-east-1",
        "ap-south-2",
        "ap-southeast-3",
        "ap-southeast-4",
        "ap-south-1",
        "ap-northeast-3",
        "ap-northeast-2",
        "ap-southeast-1",
        "ap-southeast-2",
        "ap-northeast-1",
        "ca-central-1",
        "ca-west-1",
        "eu-central-1",
        "eu-west-1",
        "eu-west-2",
        "eu-south-1",
        "eu-west-3",
        "eu-south-2",
        "eu-north-1",
        "eu-central-2",
        "il-central-1",
        "me-south-1",
        "me-central-1",
        "sa-east-1",
        "us-gov-east-1",
        "us-gov-west-1",
    ],        
    globalLoader: false,
    snackbar: {
        open: false,
        message: "",
        severity: "",
    },
    showProgressBar: false,
    progressBarValue: 0
};
export default function commonReducer(state = initialState, action) {
    switch (action.type) {
        case Types.TOGGLE_THEME:
            return {
                ...state,
                themeType: action.payload
            };
        case Types.GLOBAL_LOADER:
            return {
                ...state,
                globalLoader: action.payload
            };
        case Types.SNACKBAR:
            return {
                ...state,
                snackbar: action.payload
            };
        case Types.SHOW_PROGRESS_BAR:
            return {
                ...state,
                showProgressBar: action.payload
            };
        case Types.PROGRESS_BAR_VALUE:
            return {
                ...state,
                progressBarValue: action.payload
            };
        default:
            return state;
    }
}
